import React, { useState } from 'react';
import PropTypes from 'prop-types';

import AddControl from 'components/add_control';
import Modal from 'bundles/apex/playbooks/config/tasks/modal';

export default function AddField({ playbook, stage }) {
  const [showModal, setShowModal] = useState();

  return <React.Fragment>
    <AddControl id="add-deal-task" onClick={() => setShowModal(true)}>
      Deal Task
    </AddControl>

    {!showModal ? null :
      <Modal
        className="playbook-task-modal"
        playbook={playbook}
        stage={stage}
        onHide={() => setShowModal(false)}
      />
    }
  </React.Fragment>;
}

AddField.propTypes = {
  playbook: PropTypes.object,
  stage: PropTypes.object,
};
